import posthog from "posthog-js";

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_API_KEY;

export function initAnalytics() {
  if (!POSTHOG_KEY) return;
  posthog.init(POSTHOG_KEY, {
    api_host: "https://us.i.posthog.com",
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: true,
    disable_session_recording: true,
    advanced_disable_feature_flags: true,
    persistence: "localStorage+cookie",
    // Sprint 5h: trim unused PostHog scripts. We don't render any survey UI,
    // don't consume dead-click data, and don't read web-vitals from PostHog.
    // Disabling these prevents the corresponding lazy-loaded scripts from
    // being fetched, shaving network weight on every page load.
    disable_surveys: true,
    capture_dead_clicks: false,
    capture_performance: false,
  });
}

type AnalyticsEvent =
  | { event: "checkout_initiated"; properties: { product: string; plan?: string } }
  | { event: "upgrade_page_viewed"; properties: { reason?: string } }
  | { event: "asset_created"; properties?: undefined }
  | { event: "asset_updated"; properties?: undefined }
  | { event: "asset_deleted"; properties?: undefined }
  | { event: "photo_analyzed"; properties?: undefined }
  | { event: "value_estimated"; properties: { asset_id: string } }
  | { event: "listing_generated"; properties: { platform: string } }
  | { event: "insurance_report_exported"; properties: { format: string; asset_count: number } }
  | { event: "feature_gate_hit"; properties: { feature_key: string; required_access?: string } };

export function track(
  event: AnalyticsEvent["event"] | (string & {}),
  properties?: Record<string, unknown>,
) {
  if (!POSTHOG_KEY) return;
  posthog.capture(event, properties);
}

export function identifyUser(userId: string, traits: { email?: string }) {
  if (!POSTHOG_KEY) return;
  posthog.identify(userId, traits);
}

export function resetUser() {
  if (!POSTHOG_KEY) return;
  posthog.reset();
}

export function capturePageview() {
  if (!POSTHOG_KEY) return;
  posthog.capture("$pageview");
}
